/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { modals } from '@mantine/modals';

import i18n from '@fai/friendli-suite/features/i18n';

import SetupIntentForm from './setup-intent-form';

const addPaymentModalId = 'team-settings-add-payment-modal';

export const openAddPaymentModal = (props?: React.ComponentProps<typeof SetupIntentForm>) => {
  modals.openContextModal({
    modal: 'footerless',
    modalId: addPaymentModalId,
    title: i18n.t('team_settings.add_payment_method'),
    closeOnClickOutside: false,
    closeOnEscape: false,
    innerProps: {
      modalBody: <SetupIntentForm {...props} />,
    },
  });
};
